(function () {
  var initializedProducts = new WeakSet();

  function altColor(alt) {
    if (!alt) return null;
    var parts = alt.split(' - ');
    return parts.length > 1 ? parts.slice(1).join(' - ').trim() : null;
  }

  function createController(root) {
    var userTouched = false;
    var pollTimer = null;
    var debounceTimer = null;
    var errorReported = false;
    var styleTag = null;

    function reportError(error) {
      if (errorReported) return;
      errorReported = true;
      console.error('[Muslim Lantern] Variant image controller failed', error);
    }

    function colorValues() {
      var colors = [];
      root.querySelectorAll('.m-product-media img').forEach(function (image) {
        var color = altColor(image.alt);
        if (color && colors.indexOf(color) < 0) colors.push(color);
      });
      return colors;
    }

    function imageUrlFor(color) {
      var matches = [];
      root.querySelectorAll('.m-product-media img').forEach(function (image) {
        if (altColor(image.alt) === color) matches.push(image);
      });
      if (!matches.length) return null;

      var selected = null;
      for (var index = 0; index < matches.length; index += 1) {
        var source = matches[index].getAttribute('src') || matches[index].currentSrc || '';
        var filename = source.split('?')[0].split('/').pop() || '';
        if (/__0*1\.(jpe?g|png|webp|gif)$/i.test(filename)) {
          selected = matches[index];
          break;
        }
      }

      selected = selected || matches[0];
      var url = selected.getAttribute('src') || selected.currentSrc || '';
      if (url.indexOf('//') === 0) url = 'https:' + url;
      return url.replace(/([?&])width=\d+/, '$1width=140');
    }

    // True only for values that name a colourway, so size selections — which
    // do not change the photos — are left alone.
    function isColorOption(value) {
      return !!value && colorValues().indexOf(value) >= 0;
    }

    function selectedColor() {
      var colors = colorValues();
      if (!colors.length) return null;

      var checked = root.querySelectorAll('.m-product-option__input:checked');
      for (var index = 0; index < checked.length; index += 1) {
        if (colors.indexOf(checked[index].value) >= 0) return checked[index].value;
      }
      return colors[0];
    }

    // Swatch thumbnails are applied as a persistent stylesheet keyed on the
    // option value, NOT as inline styles on the label elements. The theme
    // re-renders the variant picker over AJAX on every selection, which
    // discards inline styles and makes the swatches flash back to plain
    // colour dots until the observer re-applies them — the flicker fixed in
    // commit 22cded8. A rule in <head> survives that re-render, and scoping
    // the selector to this product-info id keeps one product's swatches out
    // of another's (the quick-view isolation this rewrite is for).
    function applySwatches() {
      var colors = colorValues();
      if (colors.length < 2) return;

      var productId = root.getAttribute('data-product-id');
      if (!productId) return;

      var scope = 'product-info[data-product-id="' + productId + '"]';
      var css = '';

      colors.forEach(function (color) {
        var url = imageUrlFor(color);
        if (!url) return;
        var value = color.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        css += scope + ' .m-product-option__input[value="' + value + '"] + label{' +
          'background-image:url("' + url.replace(/"/g, '%22') + '") !important;' +
          'background-size:cover !important;' +
          'background-position:center top !important;' +
          'background-color:transparent !important;' +
          'border-radius:50% !important;}';
      });

      if (!css) return;

      if (!styleTag) {
        styleTag = document.createElement('style');
        styleTag.setAttribute('data-ml-swatch-style', productId);
        document.head.appendChild(styleTag);
      }
      if (styleTag.textContent !== css) styleTag.textContent = css;
    }

    function scrollToColor(force) {
      if (!force && userTouched) return;
      var color = selectedColor();
      if (!color) return;

      var active = root.querySelector('.m-media-gallery__inner .swiper-slide-active img');
      if (active && altColor(active.alt) === color) return;

      var target = null;
      root.querySelectorAll('.m-media-gallery__inner .m-product-media--item[data-index]').forEach(function (slide) {
        var image = slide.querySelector('img');
        if (!image || altColor(image.alt) !== color) return;
        var index = parseInt(slide.getAttribute('data-index'), 10);
        if (!isNaN(index) && (target === null || index < target)) target = index;
      });
      if (target === null) return;

      var gallery = root.querySelector('.m-media-gallery__inner.swiper-container') ||
        root.querySelector('.m-media-gallery__inner');
      var swiper = gallery && gallery.swiper;
      if (swiper && typeof swiper.slideToLoop === 'function') {
        swiper.slideToLoop(target);
        return;
      }
      if (swiper && typeof swiper.slideTo === 'function') {
        swiper.slideTo(target);
        return;
      }

      var selector = '.m-product-media--slider__thumbnails .swiper-slide[data-index="' + target + '"]';
      var thumbnail = root.querySelector(selector + ':not(.swiper-slide-duplicate)') ||
        root.querySelector(selector);
      if (thumbnail) thumbnail.click();
    }

    function filterDesktopGallery() {
      var color = selectedColor();
      if (!color) return;
      root.querySelectorAll('.m-product-media--item').forEach(function (item) {
        var image = item.querySelector('img');
        if (image) item.style.display = altColor(image.alt) === color ? '' : 'none';
      });
    }

    // Swiper measures the gallery when it initialises, but the frame's size is
    // settled by CSS that resolves later (an aspect-ratio box plus a
    // viewport-height cap). It can therefore finish with only part of its
    // slide grid — measured at 7 positions for a 14-slide gallery — and every
    // slide past that point becomes unreachable. That is what left the gallery
    // stuck on the last White photo when Black was picked: the scroll was
    // correct, the slide simply could not be reached. Re-measuring first
    // rebuilds the full grid.
    function refreshSwiper(swiper) {
      if (swiper && typeof swiper.update === 'function') {
        try { swiper.update(); } catch (error) { /* non-fatal */ }
      }
    }

    /* Keep the highlighted thumbnail in view.

       The rail scrolls natively (its wrapper transform is pinned, so Swiper's
       own auto-scroll does not run). Without this the rail stays where it was
       while the main image moves: pick a colour and the big image changes,
       but the rail is still parked on the previous colour's photos — so every
       thumbnail on screen is the wrong colour, and clicking one throws you
       back to where you started. */
    var lastRevealedThumb = null;
    // Set when a colour swatch was picked: that colour's first thumbnail is
    // taken to the top of the rail rather than merely nudged into view, so the
    // rail starts at the beginning of the colour just chosen.
    var alignThumbToTop = false;
    var alignThumbTimer = null;

    function revealActiveThumb() {
      var rail = root.querySelector('.m-product-media--slider__thumbnails');
      if (!rail || rail.scrollHeight <= rail.clientHeight + 4) return;

      var active = rail.querySelector('.swiper-slide-thumb-active') ||
        rail.querySelector('.swiper-slide-active');
      if (!active) return;

      var image = active.querySelector('img');
      var id = image ? mediaKey(image) : null;

      // A colour was just picked: put its thumbnail at the top of the rail.
      // Checked before the "already in view" test below, which would otherwise
      // leave the rail wherever it happened to be sitting.
      if (alignThumbToTop) {
        /* Hold the request until the gallery has actually reached the chosen
           colour. On a fresh load the rail is ready before the gallery has
           moved to the colour in the URL, and aligning then would pin the
           wrong thumbnail to the top and consume the request. */
        var activeColor = image ? altColor(image.alt) : null;
        var wantedColor = selectedColor();
        if (activeColor && wantedColor && activeColor !== wantedColor) return;

        var maximum = rail.scrollHeight - rail.clientHeight;
        var wanted = Math.max(0, Math.min(active.offsetTop, maximum));
        if (Math.abs(rail.scrollTop - wanted) > 1) rail.scrollTop = wanted;
        lastRevealedThumb = id;
        alignThumbToTop = false;
        clearTimeout(alignThumbTimer);
        return;
      }

      // Only act when the highlighted thumbnail actually changed. This runs on
      // every pass (mutations and polls), and scrolling the rail on each of
      // them fought the visitor's own scrolling — the jerkiness while browsing
      // photos.
      if (id && id === lastRevealedThumb) return;
      lastRevealedThumb = id;

      // Already fully in view: leave the rail exactly where they put it.
      var top = active.offsetTop;
      var bottom = top + active.offsetHeight;
      var viewTop = rail.scrollTop;
      var viewBottom = viewTop + rail.clientHeight;
      if (top >= viewTop - 2 && bottom <= viewBottom + 2) return;

      // Otherwise move the least amount that brings it into view, instantly —
      // an animated scroll here reads as lag when clicking through photos.
      var target = top < viewTop ? top : bottom - rail.clientHeight;
      rail.scrollTop = Math.max(0, Math.min(target, rail.scrollHeight - rail.clientHeight));
    }

    /* The exact photo the visitor opened, when opening it also changed the
       colour. Without this the gallery lands on that colour's first photo —
       so clicking a model shot showed the flat lay, and only a second click
       on the same thumbnail got you the model. Identified by filename, since
       the theme rebuilds the gallery for the new variant and the elements
       from the click no longer exist. */
    var desiredMedia = null;
    var desiredMediaTimer = null;

    function mediaKey(image) {
      var source = image.getAttribute('src') || image.currentSrc || '';
      return source.split('?')[0].split('/').pop() || null;
    }

    // Returns true when it has handled the positioning, so the colour-level
    // scroll is skipped and the two cannot fight over the same gallery.
    function scrollToMedia() {
      if (!desiredMedia) return false;

      var gallery = root.querySelector('.m-media-gallery__inner');
      var swiper = gallery && gallery.swiper;
      if (!swiper || !swiper.slides || !swiper.slides.length) return true;

      // Already showing it — but do NOT clear the request yet. The theme's own
      // variant handler runs after this and snaps the gallery to the variant's
      // featured image, which is the flat lay: traced landing correctly at
      // 400ms and being pulled back to __01 at 900ms. Holding the request lets
      // the next pass put it back. It is released by the timer below, or as
      // soon as the visitor touches the gallery themselves.
      var active = gallery.querySelector('.swiper-slide-active img');
      if (active && mediaKey(active) === desiredMedia) return true;

      for (var index = 0; index < swiper.slides.length; index += 1) {
        var slide = swiper.slides[index];
        if (String(slide.className).indexOf('duplicate') >= 0) continue;
        var image = slide.querySelector('img');
        if (!image || mediaKey(image) !== desiredMedia) continue;

        var loopIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        if (isNaN(loopIndex)) loopIndex = index;
        // Speed 0: jump straight there. Animating the correction slides the
        // gallery visibly through the flat lay on its way, which is the
        // stutter when moving between model shots of two colours.
        if (typeof swiper.slideToLoop === 'function') swiper.slideToLoop(loopIndex, 0);
        else swiper.slideTo(index, 0);
        return true;
      }
      return true;
    }

    function applyGallery(force) {
      var gallery = root.querySelector('.m-media-gallery__inner');
      var swiper = gallery && gallery.swiper;
      if (swiper && swiper.slides && swiper.slides.length) {
        refreshSwiper(swiper);
        var thumbs = root.querySelector('.nav-swiper-container');
        if (thumbs) refreshSwiper(thumbs.swiper);
        root.querySelectorAll('.m-product-media--item').forEach(function (item) {
          if (item.style.display === 'none') item.style.display = '';
        });
        // A specific photo was opened; that beats jumping to the colour's first.
        if (scrollToMedia()) {
          setTimeout(revealActiveThumb, 250);
          return;
        }
        scrollToColor(force);
        // After the main image settles, bring its thumbnail into view so the
        // rail is never showing a different colour than the one selected.
        setTimeout(revealActiveThumb, 250);
      } else {
        filterDesktopGallery();
      }
    }

    function apply(force) {
      try {
        applySwatches();
        applyGallery(force);
      } catch (error) {
        reportError(error);
      }
    }

    function applyDebounced() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { apply(false); }, 80);
    }

    root.addEventListener('change', function (event) {
      if (event.target && event.target.classList.contains('m-product-option__input')) {
        /* A colour swatch was picked: start the rail at that colour's first
           thumbnail. Skipped when desiredMedia is set, because that means a
           thumbnail drove this change and the visitor asked for a specific
           photo — moving the rail to the top of the colour would scroll their
           choice away. Skipped for size options too, which do not change the
           photos at all. */
        if (!desiredMedia && isColorOption(event.target.value)) {
          alignThumbToTop = true;
          clearTimeout(alignThumbTimer);
          alignThumbTimer = setTimeout(function () { alignThumbToTop = false; }, 3000);
        }
        setTimeout(function () { apply(true); }, 50);
      }
    });

    /* Opening a thumbnail of another colour selects that colour, so the
       swatches and the gallery never disagree.

       Bound to an explicit click rather than to which slide is active: the
       active slide changes on every scroll, including the ones this script
       performs, which is what made an earlier attempt at this loop between
       the two directions. A click is unambiguously the visitor asking for
       that colour, so no guards or timers are needed — the colour change
       then runs the normal path and the gallery follows.

       Capture phase so this is seen before Swiper handles the click, and
       delegated from the root so it survives the theme re-rendering the
       gallery. Works the same for the rail on desktop and the strip on
       mobile — both are the same thumbnail element. */
    root.addEventListener('click', function (event) {
      var slide = event.target.closest &&
        event.target.closest('.m-product-media--slider__thumbnails .swiper-slide');
      if (!slide) return;

      var image = slide.querySelector('img');
      var color = image && altColor(image.alt);
      if (!color || color === selectedColor()) return;

      var inputs = root.querySelectorAll('.m-product-option__input');
      for (var index = 0; index < inputs.length; index += 1) {
        if (inputs[index].value !== color || inputs[index].checked) continue;

        // Remember the photo actually opened, so the gallery lands on it
        // rather than on this colour's first photo.
        desiredMedia = mediaKey(image);
        clearTimeout(desiredMediaTimer);
        desiredMediaTimer = setTimeout(function () { desiredMedia = null; }, 3000);

        inputs[index].checked = true;
        // The theme listens for `change` to swap variant, price and URL.
        inputs[index].dispatchEvent(new Event('change', { bubbles: true }));

        /* The theme snaps the gallery to the variant's featured image partway
           through the change. Watch every frame and put it back the moment it
           moves: on a timer the flat lay was on screen for around half a
           second before being corrected, which is what made this feel like it
           needed a second click. Checking per frame keeps that to roughly one
           frame, below what reads as a flash. */
        var deadline = Date.now() + 3000;
        var watch = function () {
          if (!desiredMedia || Date.now() > deadline) return;
          var gallery = root.querySelector('.m-media-gallery__inner');
          var active = gallery && gallery.querySelector('.swiper-slide-active img');
          if (active && mediaKey(active) !== desiredMedia) scrollToMedia();
          requestAnimationFrame(watch);
        };
        requestAnimationFrame(watch);
        return;
      }
    }, true);

    ['pointerdown', 'touchstart', 'mousedown'].forEach(function (eventName) {
      root.addEventListener(eventName, function (event) {
        if (!event.target.closest('.m-media-gallery__inner')) return;
        userTouched = true;
        // Their swipe wins over any photo we were still trying to restore.
        desiredMedia = null;
        clearTimeout(desiredMediaTimer);
        if (pollTimer) {
          clearInterval(pollTimer);
          pollTimer = null;
        }
      }, { passive: true });
    });

    var observer = new MutationObserver(function (mutations) {
      var hasAddedNodes = mutations.some(function (mutation) {
        return mutation.addedNodes && mutation.addedNodes.length;
      });
      if (hasAddedNodes) applyDebounced();
    });
    observer.observe(root, { childList: true, subtree: true });

    /* Arriving with a colour already chosen — a colourway card in a listing
       links straight to that variant — should start the rail at that colour
       too, exactly as picking the swatch here does. There is no change event
       on a fresh load, so ask for the alignment up front. The request waits
       for the gallery to reach that colour before it is spent, and lapses on
       its own if the product has only one colourway. */
    if (colorValues().length > 1) {
      alignThumbToTop = true;
      clearTimeout(alignThumbTimer);
      alignThumbTimer = setTimeout(function () { alignThumbToTop = false; }, 6000);
    }

    apply(false);
    setTimeout(function () { apply(false); }, 500);
    setTimeout(function () { apply(false); }, 1400);

    var polls = 0;
    pollTimer = setInterval(function () {
      apply(false);
      polls += 1;
      if (polls >= 20) {
        clearInterval(pollTimer);
        pollTimer = null;
      }
    }, 300);
  }

  function initializeProduct(root) {
    if (!root || initializedProducts.has(root)) return;
    initializedProducts.add(root);
    createController(root);
  }

  function initializeWithin(container) {
    if (container.matches && container.matches('product-info[data-product-id]')) {
      initializeProduct(container);
    }
    if (container.querySelectorAll) {
      container.querySelectorAll('product-info[data-product-id]').forEach(initializeProduct);
    }
  }

  function initialize() {
    initializeWithin(document);
    var discoveryObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) initializeWithin(node);
        });
      });
    });
    discoveryObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') initialize();
  else document.addEventListener('DOMContentLoaded', initialize);
})();